import { render, staticRenderFns } from "./User.vue?vue&type=template&id=27f4cc82&"
import script from "./User.vue?vue&type=script&setup=true&lang=js&"
export * from "./User.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports